
export let partPool = new WeakMap();
